import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import AccessControl from "../../../../../../HOC/AccessControl";
import Icon from "../../../../../../components/Icon";

const Panel = ({ onDelete }) => {
  return (
    <div className={cn("panel", styles.panel)}>
      <div className={styles.info}></div>
      <div className={styles.btns}>
        <AccessControl moduleCode="FvrVqN" requiredPrivilege="cifHqu">
          <button
            className={cn("button-stroke", styles.button)}
            onClick={onDelete}
          >
            <Icon name="trash" size="24" />
            <span>Delete</span>
          </button>
        </AccessControl>
        <AccessControl moduleCode="FvrVqN" requiredPrivilege="cifHqu">
          <button className={cn("button", styles.button)} type="submit">
            Save
          </button>
        </AccessControl>
      </div>
    </div>
  );
};
export default Panel;
